import styled, { css } from 'styled-components'
import { tokens } from 'app-v2/design-systems/theme/tokens'
import { media } from 'app/assets/styles'
import { COLOR, TEXT } from 'app-v2/design-tokens'

export const H5 = styled.h5`
    font-family: ${TEXT.FONT_FAMILY.DEFAULT};
    font-size: 28px;
    line-height: 28px;
    ${media.medium`
        font-size: 36px;
        line-height: 36px;
    `};
    color: ${props => (props.color ? props.color : COLOR.PRIMARY)};
`

export const H6 = styled.h6`
    font-family: ${TEXT.FONT_FAMILY.DEFAULT};
    font-size: 16px;
    line-height: 16px;
    ${media.medium`
        font-size: 24px;
        line-height: 24px;
    `};
    color: ${props => (props.color ? props.color : COLOR.PRIMARY)};
`

export const H7 = styled.span`
    font-family: ${TEXT.FONT_FAMILY.DEFAULT};
    font-size: 20px;
    line-height: 20px;
    color: ${props => (props.color ? props.color : COLOR.PRIMARY)};
`

export const H8 = styled.span`
    font-family: ${tokens.h8FontFamily};
    font-size: 18px;
    line-height: 18px;
    color: ${props => (props.color ? props.color : COLOR.PRIMARY)};
`

export const H9 = styled.span`
    font-family: ${TEXT.FONT_FAMILY.DEFAULT};
    font-size: 15px;
    line-height: 22px;
    color: ${props => (props.color ? props.color : COLOR.PRIMARY)};
`
